import { useTheme } from '@mui/material/styles'

import type { DonutChartBlockData } from '../../../../core/types/InsightsInstanceSlotData'

import { formatValueByType } from '../../../CommonUtils'

import type { BlockProps } from '../../types'

import DonutChartV2 from './DonutChart'
import { getDonutChartColors } from './utils'

const DonutChartBlock = ({ payload }: BlockProps<DonutChartBlockData>) => {
  const theme = useTheme()
  const { instance_slot, instance_slot_data } = payload
  const { variant } = instance_slot
  const { legends = [], main } = instance_slot_data
  const colors = getDonutChartColors(variant, instance_slot_data, theme)

  const data = legends.map((legend: (typeof legends)[number], index: number) => ({
    value: legend.value,
    color: colors[index],
    label: legend.label,
    labelValue: (
      <>
        <b>{formatValueByType(legend.value, legend.value_type ?? 'amount', '0,0.00')}</b>
        {legend.additional_value && legend.additional_value_type
          ? ` (${formatValueByType(legend.additional_value, legend.additional_value_type, '0,0.00')})`
          : null}
      </>
    ),
  }))

  return (
    <DonutChartV2
      centerLabel={main.label}
      centerValue={formatValueByType(Number(main.value), main.value_type, '0,0')}
      data={data}
    />
  )
}

export default DonutChartBlock
